<template>
	<header class="group site-header">
		<logo></logo>

		<button class="toggle-nav" @click="toggleNav"><font-awesome-icon icon="bars" /></button>

		<nav v-bind:class="{ showNav: showNav }">
			
			<div class="maintenance" v-bind:class="[stateClass]" v-if="maintenance && maintenance.maintenanceEnabled === true" @click="showMaintenanceModal">
				<div class="maintenance-icon">
					<font-awesome-icon icon="wrench" />
				</div>
				<div>
					Maintenance: <br /> {{startTime(maintenance)}} <br/> Click for more info
				</div>
			</div>
			<home-icon v-if="userAuthenticated"></home-icon>
			<help-icon></help-icon>
			<log-out-icon v-if="userAuthenticated"></log-out-icon>
		</nav>

		<modal v-if="isModalVisible" @close="closeModal" @backgroundClicked="closeModal">
			<h2 slot="header">Whats New?</h2>
			<div slot="body">
				<div class="container" v-if="maintenance && maintenance.maintenanceEnabled === true">
					<section v-if="maintenance.globeFeatures.length > 0">
						<h4>Globe Features</h4>
						<pre>{{maintenance.globeFeatures}}</pre>
					</section>
					<section v-if="maintenance.globeBugFixes.length > 0">
						<h4>Globe Bug Fixes</h4>
						<pre>{{maintenance.globeBugFixes}}</pre>
					</section>

					<section v-if="maintenance.nbsFeatures.length > 0">
						<h4>NBS Features</h4>
						<pre>{{maintenance.nbsFeatures}}</pre>
					</section>
					<section v-if="maintenance.nbsBugFixes.length > 0">
						<h4>NBS Bug Fixes</h4>
						<pre>{{maintenance.nbsBugFixes}}</pre>
					</section>

					<section v-if="maintenance.bmeFeatures.length > 0">
						<h4>BME Features</h4>
						<pre>{{maintenance.bmeFeatures}}</pre>
					</section>
					<section v-if="maintenance.bmeBugFixes.length > 0">
						<h4>BME Bug Fixes</h4>
						<pre>{{maintenance.bmeBugFixes}}</pre>
					</section>

					<section v-if="maintenance.dataRollout.length > 0">
						<h4>Data Rollout</h4>
						<pre>{{maintenance.dataRollout}}</pre>
					</section>
				</div>
			</div>
		</modal>
	</header>

</template>

<script>
/* eslint-disable */
	import Logo from './Logo'
	import HomeIcon from './HomeIcon'
	import HelpIcon from './HelpIcon'
	import LogOutIcon from './LogOutIcon'
	import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
	import { mapState } from 'vuex'
	import moment from 'moment'
	import Modal from '../reusable/Modal'

	export default {
		name: 'SiteHeader',
		data() {
			return {
				showNav: false,
				isModalVisible: false
			}
		},
		components: {
			Logo,
			HomeIcon,
			HelpIcon,
			LogOutIcon,
			FontAwesomeIcon,
			Modal
		},
		props: ['userAuthenticated'],
		created() {		
			this.$store.dispatch('maintenancemodule/getMaintenance').then(results => {
			});
		},
		computed: {
			...mapState({
				maintenance: state => state.maintenancemodule.currentMaintenance,
				dateString: state => state.maintenancemodule.dateString,
				stateClass: state => state.maintenancemodule.stateClass
			}),
			m: {
				get() {
					return this.$store.state.maintenancemodule.currentMaintenance
				},
				set(value) {

				}
			},
		},
		methods: {
			showMaintenanceModal() {
				this.isModalVisible = true
			},
			closeModal() {
				this.isModalVisible = false;
			},
			toggleNav() {
				this.showNav = !this.showNav;
			},
			moment: function (date) {
				return moment(date);
			},
			startTime: function (data) {
				var start = moment(data.maintenanceDueDateTimeString, 'DD/MM/YYYY HH:mm').format('DD/MM h:mma');
				var end = moment(data.maintenanceDueDateTimeString, 'DD/MM/YYYY HH:mm').add(data.maintenanceLength, 'minutes').format('h:mma');
				return start + ' - ' + end;
			}
		}
	}
</script>

<style lang="scss" scoped>
	header {
		border-bottom: 1px solid #ececec;
		background-color: #fff;
	}

	.logo {
		float: left;
	}

	nav{
		float:right;
	}

	.header-icon {
		margin-top: 18px;
		float: left;
		margin-right: 2em;
	}

	.toggle-nav{
		display:none;
		float:right;
		margin-right:30px;
		background:none;
		border:0;
		font-size:30px;
		margin-top:30px;
	}

	.maintenance {
		float: left;
		margin-top: 10px;
		margin-right: 28px;
		border: 2px solid #525252;
		border-radius: 9px;
		padding: 10px;
		cursor: pointer;
		display:flex;
	}

	.maintenance:hover {
		background: #52525224;
	}

	.maintenance.warn {
		color: #fff;
		background-color: #d9534f;
		border-color: #d43f3a;
	}

    .maintenance.warn:hover {
        background-color: #c9302c;
        border-color: #ac2925;
    }

	.maintenance-icon {
		font-size:2em;
		width: 44px;
		line-height: 1.6em;
	}

	pre {
		padding: 0;
		margin: 0;
		font-size: 1em;
		font-family: 'Montserrat', sans-serif;
		color: inherit;
		background-color: inherit;
		line-height: inherit;
		border: none;
	}

	h4 {
		margin-bottom: 2px;
		margin-top: 2px;
	}

	@media only screen and (max-width: 800px){
		.toggle-nav{
			display:block;
		}

		nav{
			display:none;
			clear: both;
			text-align: left;
			float: left;
			position: absolute;
			top: 101px;
			background: #fdfdfd;
			width: 100%;
			padding-bottom:20px;
			padding-left:20px;
			border-bottom:1px solid #ececec;

			.header-icon{
				float:left;
			}
		}

		nav.showNav{
			display:block;
		}
	}
</style>
